<template>
  <!-- 应付主体 下拉列表 -->
  <el-select
    v-model="value"
    :loading="loading"
    :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
    style="width: 100%;"
    :clearable="clearable"
    :multiple="multiple"
    :multiple-limit="multipleLimit"
    filterable
    :remote="type !== 5"
    :reserve-keyword="multiple"
    :remote-method="getProviderPage"
    @change="onChange"
  >
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import { apiProviderPage, apiOptionForSelect } from '@/api/finance/basicData';
import { cloneDeep } from 'lodash-es';
const param = {
  pageSize: 10,
  pageNumber: 1,
  params: {
    state: 1
  }
};

export default {
  props: {
    // 应付主体id 用于 回显的内容
    val: {
      type: [Number, String],
      default: ''
    },

    // 业务类型 1 安骏 2 第三方 3 AJD 4 DSP 5 干支线 6 邮局
    type: {
      type: [Number, String],
      default: ''
    },

    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },

    // 是否可以清空选项
    clearable: {
      type: Boolean,
      default: true
    },

    // 多选时用户最多可以选择的项目数，为 0 则不限制
    multipleLimit: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      loading: false,
      list: [],
      value: []
    };
  },

  watch: {
    'val': {
      handler() {
        this.value = this.val;
      }
      // immediate: true
    },
    type: {
      handler() {
        this.getProviderPage();
      }
    }
  },

  created() {
    setTimeout(() => {
      this.getProviderPage();
    }, 500);
  },

  methods: {
    // 获取应付主体选项
    getProviderPage(name = '') {
      this.loading = true;
      let params = cloneDeep(param);
      let API;
      // 运输业务单独调用调度主体
      if (this.type === 5) {
        params = {
          providerName: name,
          status: 2
        };
        API = apiOptionForSelect;
      } else {
        params.params.providerBody = name;
        API = apiProviderPage;
      }
      // 运输不支持远程搜索，直接return
      if (this.type === 5 && name !== '') {
        return;
      }
      API(params, false).then(res => {
        const { code, data } = res;
        if (code === 200) {
          this.list = this.type === 5 ? data.map(item => {
            const { providerId, name, code } = item;
            const obj = {
              label: `${name}（${code}）`,
              value: providerId
            };
            return Object.freeze(obj);
          }) : data.records.map(item => {
            const { id, providerBody, providerName, code } = item;
            const obj = {
              label: `${providerBody}（${providerName}）（${code}）`,
              value: id
            };
            return Object.freeze(obj);
          });
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    onChange(val) {
      this.$emit('change', val);
    }
  }

};
</script>

<style lang="scss" scoped>
</style>
